export enum ColorStyle {
  None= 'None',
  Light = 'Light',
  Blue = 'Blue',
  BlueSea = 'BlueSea',
  Grey = 'Grey',
  SlateGrey = 'SlateGrey',
  Green = 'Green',
  Red = 'Red',
  Yellow = 'Yellow',
  Dark = 'Dark'
}
